/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import Promise from 'bluebird';
import pageContext from '@bingads-webui-static-legacy/page-context';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import AdGroupCollection from '@bingads-webui-static-legacy/wunderbar/data/collections/adgroups';
import CampaignCollection from '@bingads-webui-static-legacy/wunderbar/data/collections/campaigns';
import Pristine from '@bingads-webui-static-legacy/wunderbar/data/collections/pristine';
var adgroupRequest = {
  promise: null,
  campaignId: null,
  adgroupId: null
}, campaignRequest = {
  promise: null,
  campaignId: null
};
var adgroups = new Pristine(new AdGroupCollection());
var campaigns = new Pristine(new CampaignCollection());
function userParameters() {
  var params = {
    cid: pageContext.CurrentCustomer.Id,
    uid: pageContext.CurrentUser.Id,
    aid: pageContext.CurrentAccount.Id
  };
  return $.param(params) + '&';
}
function clearPromise(request) {
  return function () {
    request.promise = null;
    request.campaignId = null;
    if (request.adgroupId) {
      request.adgroupId = null;
    }
  };
}
var getPristineRequest = function (options) {
  options = options || ({});
  options.data = options.data || ({});
  options.http_method = 'GET';
  options.hideLoadingPanelOnSuccess = false;
  options.ignoreBeforeAjax = true;
  return options;
};
export default {
  getAdgroup: function (campaignId, adgroupId) {
    if (adgroupRequest.campaignId === campaignId && adgroupRequest.adgroupId === adgroupId && adgroupRequest.promise) {
      return adgroupRequest.promise;
    } else {
      adgroupRequest.campaignId = campaignId;
      adgroupRequest.adgroupId = adgroupId;
      adgroupRequest.promise = $.get('/campaign/wunderbar/getAdgroup?' + userParameters() + $.param({
        'cmpid': campaignId,
        'adgid': adgroupId
      }));
      adgroupRequest.promise.then(function (data) {
        window.selectedAdgroupLanguage = data ? data.Language : undefined;
      });
      adgroupRequest.promise.then(clearPromise(adgroupRequest), clearPromise(adgroupRequest));
      return adgroupRequest.promise;
    }
  },
  getCampaign: function (campaignId, experimentId) {
    if (campaignRequest.campaignId === campaignId && campaignRequest.promise) {
      return campaignRequest.promise;
    } else {
      campaignRequest.campaignId = campaignId;
      campaignRequest.promise = $.get('/campaign/wunderbar/getCampaign?' + userParameters() + $.param({
        'cmpid': campaignId
      }));
      if (experimentId) {
        var fetchExperimentTask = jsdata.Experiment.find(experimentId, {
          bypassCache: true,
          cacheResponse: true
        });
        campaignRequest.promise = Promise.join(campaignRequest.promise, fetchExperimentTask).then(function (results) {
          return _.defaults({}, results[1], results[0]);
        });
      }
      campaignRequest.promise.then(clearPromise(campaignRequest), clearPromise(campaignRequest));
      return campaignRequest.promise;
    }
  },
  getCampaigns: function (options) {
    campaigns.fetch(getPristineRequest(options), Pristine.getPristineKey('Campaigns'));
  },
  getAdgroups: function (options) {
    adgroups.fetch(getPristineRequest(options), Pristine.getPristineKey('AdGroups', options.data.campaignId));
  }
};

